import type { ReactNode } from 'react'
import ThemeProvider from '@mui/material/styles/ThemeProvider'
import CssBaseline from '@mui/material/CssBaseline'
import { theme } from '@/services/theme'
import { ToastProvider } from '@/shared/toast/ToastProvider'
import { QueryProvider } from './QueryProvider'

export function AppProviders({
  children,
}: Readonly<{ children: ReactNode }>) {
  return (
    <QueryProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ToastProvider>{children}</ToastProvider>
      </ThemeProvider>
    </QueryProvider>
  )
}
